import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface DecodedSignInToken {
  companyId: string | number;
  eventId: string | number;
  event: any;
  attendee?: any;
}

@Injectable({ providedIn: 'root' })
export class SigninEventTokenService {
  private http = inject(HttpClient);

  decodeToken(payload: { token: string; type: string }): Observable<DecodedSignInToken> {
    const url = `${environment.apiUrl}/api/event_tokens/decode`;
    return this.http.post<DecodedSignInToken>(url, payload);
  }
}
